module.exports = __webpack_public_path__ + "static/media/logo-with-text.257bbffc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/assets/logos/logo-with-text.svg
// module id = 1760
// module chunks = 0